<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @search-reset="searchClear"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot="searchMenu">
          <!-- <el-button
            size="small"
            class="el-icon-delete"
            @click="searchClear"
            style="width: 80px;left: -88px;position: relative;"
          >清空</el-button>-->
        </template>

        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-printer"
            size="small"
            plain
            @click.stop="printJson()"
          >打印</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="downloadExcelLog()"
          >下载Excel</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            icon="el-icon"
            plain
            @click.stop="handleEdit(scope.row)"
          >编辑</el-button>
        </template>
        <template slot="search"></template>
        <template
          slot-scope="scope"
          slot="purchasePowerForm"
        >
          <el-checkbox-group v-model="checkedGoods">
            <el-checkbox
              v-for="item in Goods"
              :label="item.id"
              :key="item.id"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </template>
        <template
          slot-scope="scope"
          slot="purchasePower"
        >
          <div v-bind="scope">{{scope.row.permissionList}}</div>
        </template>
      </avue-crud>
      <el-dialog
        title="采购分类权限"
        :visible.sync="dialogVisible"
        width="50%"
        :data="dialog"
        style="background-color: #4E5465"
      >
        <el-tree
          :data="selectRolePermissions"
          ref="tree"
          default-expand-all
          show-checkbox
          node-key="id"
        ></el-tree>

        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="updatePosition()"
          >确 定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

    <script>
import { mapGetters } from "vuex";
import { purchaseOption } from "@/const/salesCloud/purchaseOption";
import {
  statusSearch,
  evaluation,
  immediatePay,
  insertWorkOrderMerchants,
  cancelWorkOrder,
} from "@/api/salesCloud/workOrder";
import {
  findShop,
  findShopDownloadExcel,
  findFristList,
  findClassify,
  findClassifySecond,
  findSecondList,
  updateShopPermissionById,
} from "@/api/salesCloud/purchase";
import {
  permissionMenusByDepart,
  permissionMenusByPosition,
} from "@/api/salesCloud/position";
import { getCompany } from "@/util/auth";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findUserInfo } from "@/api/basic/user";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
import { exportExcel } from "xlsx-oc";
import { excelaxios } from "@/util/excelaxios";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { log } from "util";
export default {
  name: "purchase",
  components: {
    VueQr,
  },
  data() {
    return {
      tableOption: purchaseOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      checkedGoods: [], //权限选中
      Goods: [],
      tableLoading: false,
      eleDialog: false,
      dialogVisible: false,
      selectRolePermissions: [],
      serviceCategoryId: "",
      serviceItemId: "",
      firstIds: [],
      payTime: {},
      dialog: [],
      from: {
        text: "text",
      },
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      evaluateDialog: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      stockSuperviseDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      value: "",
      downloadData: {},
    };
  },
  created() {
    this.handleList();
    findFristList().then((res) => {
      let data = JSON.parse(res.data);
      data.map((item) => {
        this.firstIds.push(item.id);
      });
    });
    findSecondList().then((res) => {
      let data = JSON.parse(res.data);
      this.Goods = data;
      console.log(data);
      this.checkedGoods = data.map((i) => {
        return i.id;
      });
      this.checkedGoodsInit = this.checkedGoods;
      this.goodsLength = this.checkedGoods.length;
      console.log(this.checkedGoods.length);
    });
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    updatePosition() {
      let firstIds = this.firstIds;
      let checkedGoodsIds = this.$refs.tree.getCheckedKeys();
      for (let i in checkedGoodsIds) {
        firstIds.map((item) => {
          if (item == checkedGoodsIds[i]) {
            checkedGoodsIds.splice(i, 1);
          } else {
            // console.log("不重复");
          }
        });
        // console.log(checkedGoodsIds[i]);

        // console.log(i);
      }
      console.log(checkedGoodsIds);
      console.log(this.dialog.id);
      let params = {
        ids: checkedGoodsIds,
      };
      updateShopPermissionById(this.dialog.id, params).then((res) => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改权限成功",
            type: "success",
          });
          this.handleList();
          this.dialogVisible = false;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });

      // checkedGoodsIds.map(item => {
      //   // console.log(item);
      //   firstIds.map(item => {
      //     console.log(item);
      //   });
      // });
    },
    handleDialog(row, index) {
      this.stockSuperviseDialog = true;
      // this.evaluateDialog =true
      this.formobj = row;
      console.log(row, index);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;

      this.downloadData = params;
      findShop(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        data.rows.map((item) => {
          item.permissionList = item.permissionList ? item.permissionList : 0;
          if (item.permissionList.length === this.goodsLength) {
            item.permissionList = "-";
          } else if (item.permissionList === 0) {
            item.permissionList = "请配置权限";
          } else {
            item.permissionList = item.permissionList.join(",");
          }
        });
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;

      this.downloadData = params;
      findShop(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        data.rows.map((item) => {
          item.permissionList = item.permissionList ? item.permissionList : 0;
          if (item.permissionList.length === this.goodsLength) {
            item.permissionList = "-";
          } else if (item.permissionList === 0) {
            item.permissionList = "请配置权限";
            console.log(this.checkedGoods);
          } else {
            item.permissionList = item.permissionList.join(",");
          }
        });
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      // this.$refs.crud.$refs.searchForm.resetFields();
      this.serviceCategory = "";
      this.serviceCategoryId = "";
      this.serviceItem = "";
      this.serviceItemId = "";
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.serviceCategoryId = this.serviceCategory.id;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      }
      this.downloadData = params;
      console.log(params);
      console.log(this);
      findShop(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        data.rows.map((item) => {
          item.permissionList = item.permissionList ? item.permissionList : 0;
          if (item.permissionList.length === this.goodsLength) {
            item.permissionList = "-";
          } else if (item.permissionList === 0) {
            item.permissionList = "请配置权限";
            console.log(this.checkedGoods);
          } else {
            item.permissionList = item.permissionList.join(",");
          }
        });
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      findShop(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        data.rows.map((item) => {
          // console.log(item);
          // console.log(this.checkedGoods);
          // console.log(this.Goods);
          item.permissionList = item.permissionList ? item.permissionList : 0;
          if (item.permissionList.length === this.goodsLength) {
            item.permissionList = "-";
          } else if (item.permissionList === 0) {
            item.permissionList = "请配置权限";
            // console.log(this.checkedGoods);
          } else {
            item.permissionList = item.permissionList.join(",");
          }
        });
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit(row) {
      this.dialog.id = row.id;
      let _this = this;
      console.log(_this);
      console.log(row);
      findClassify().then((res) => {
        let data = JSON.parse(res.data);
        //data 数据默认为 label显示名 chlidren 二级分类 可以通过defualtProps改变
        data.map((item) => {
          item.children.map((i) => {
            i.label = i.name;
            return i;
          });
          return item;
        });
        this.selectRolePermissions = data;
        findClassifySecond(row.id).then((res) => {
          let data = JSON.parse(res.data);
          // console.log(data.purchasePower.split(",")); //需要传数组
          _this.$refs.tree.setCheckedKeys(data.purchasePower.split(","));
        });
      });
      this.dialogVisible = true;

      // console.log(scope);
      // console.log(scope.row.purchasePower);
      // console.log(this.checkedGoods);
      // this.checkedGoods = scope.row.purchasePower
      //   ? scope.row.purchasePower.split(",")
      //   : this.checkedGoodsInit;
      // console.log(this.checkedGoods);
      // this.$refs.crud.rowEdit(scope.row);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      findShop(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        data.rows.map((item) => {
          // console.log(item);
          // console.log(this.checkedGoods);
          // console.log(this.Goods);
          item.permissionList = item.permissionList ? item.permissionList : 0;
          if (item.permissionList.length === this.goodsLength) {
            item.permissionList = "-";
          } else if (item.permissionList === 0) {
            item.permissionList = "请配置权限";
            // console.log(this.checkedGoods);
          } else {
            item.permissionList = item.permissionList.join(",");
          }
        });
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      row.serviceItemId = this.serviceItem;
      console.log("serviceItem：" + JSON.stringify(this.serviceItem));
      insertWorkOrderMerchants(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log("save", row);
      let params = {
        ids: this.checkedGoods,
      };
      console.log(row);
      console.log(params);
      updateShopPermissionById(row.id, params).then((res) => {
        console.log(res);
        this.handleList();
      });
      done();
    },
    immediatePayment(row) {
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      immediatePay(obj).then((response) => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then((res) => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function () {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success",
                  });
                  _this.handleList();
                }, 1000);
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error",
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
          done();
          this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    showEvaluate(row) {
      this.evaluateObj.workOrderId = row.id;
      this.evaluateDialog = true;
    },
    rateChange() {
      //alert(this.evaluateObj.score);
    },
    evaluate() {
      // this.evaluateObj.workOrderId=row.id;
      console.log("集合：" + JSON.stringify(this.evaluateObj));
      // evaluation(this.serviceCategory.id).then((res) => {
      //     let data = JSON.parse(res.data)
      //     this.joinsWorkServiceItems = data
      // })

      evaluation(this.evaluateObj)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "评价成功",
              type: "success",
            });
            this.handleList();
            this.evaluateDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
    },
    serviceListing(row) {
      console.log(row);
      console.log(this);
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    cancelWorkOrder(id) {
      this.$confirm(`是否确认取消?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cancelWorkOrder(id)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "取消成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    downloadExcelLog() {
      // let url = `/joins-sales-cloud/v1/shop/exportShopPermission?`;
      // let params = {};
      // params = this.downloadData;
      // console.log(params);
      // excelaxios(url, params);
      let params = this.downloadData;
      params.size = this.page.total;
      findShopDownloadExcel(params).then((res) => {
        window.open(res.data);
      });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findShop(params).then((res) => {
        let data = JSON.parse(res.data);
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map((item) => {
          item.updateTime = item.updateTime
            ? formatterDateToUTC(item.updateTime)
            : "";
          console.log(item);
          item.updateName = item.updateName ? item.updateName : "";
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "account", displayName: "账号" },
            { field: "shopName", displayName: "店铺名称" },
            { field: "name", displayName: "法人名称" },
            { field: "address", displayName: "店铺地址" },
            { field: "permissionList", displayName: "采购分类权限" },
            { field: "updateTime", displayName: "更新时间" },
            { field: "updateName", displayName: "操作人" },
          ],
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;padding:8px 10px ;text-align:center",
          type: "json",
        });
      });
    },
  },
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
